import React from 'react';

/**
 * Lets components rendered in the tiles of the case listing (e.g. the case header menu)
 * reload the report after they changed a case.
 */
export const CaseListingRefreshContext = React.createContext<(() => void) | undefined>(undefined);
